import { useMemo, useEffect } from "react";

const copyStyles = (sourceDocument, targetDocument) => {
  const nodes = [
    ...Array.from(sourceDocument.head.getElementsByTagName("style")),
    ...Array.from(sourceDocument.head.getElementsByTagName("link")).filter(
      link => link.rel === "stylesheet"
    )
  ];
  nodes.forEach(node => targetDocument.head.append(node.cloneNode(true)));
};

const useElementPrinter = el => {
  const frame = useMemo(() => {
    const iFrame = document.createElement("iframe");
    iFrame.setAttribute("src", "about:blank");
    iFrame.setAttribute("width", 0);
    iFrame.setAttribute("height", 0);
    iFrame.addEventListener("load", () => {
      copyStyles(document, iFrame.contentDocument);
      iFrame.contentDocument.body.innerHTML = el.innerHTML;
    });
    return iFrame;
  }, [el]);

  useEffect(() => {
    document.body.append(frame);
    return () => {
      frame.remove();
    };
  }, [frame]);

  return () => {
    frame.contentWindow.focus();
    frame.contentWindow.print();
  };
};

export default useElementPrinter;
